import { Box, Flex, Text } from '@chakra-ui/react';
import { ImagesCarousel } from './imagesCarousel';
import { SectionHeader } from 'src/components/SectionHeader/sectionHeader';
import React, { useState } from 'react';
import { IGame } from '../../../providers/Games/useGames';
import { t } from 'i18next';
import { CodeSection } from 'react-code-section-lib';

interface IGameContent {
	about: string;
	gamePaper: string;
	screens: string[];
	video: string;
	cta: string;
	providedGameData: IGame;
}

export const GameContent = ({ about, screens, cta, providedGameData }: IGameContent) => {
	const [isExpanded, setIsExpanded] = useState(false);

	const toggleIsExpanded = () => {
		setIsExpanded(previousState => !previousState);
	};

	return (
		<Flex
			flexDirection="column"
			gridGap="12px"
			paddingX="4px"
		>
			<ImagesCarousel
				arrowsColor={cta}
				screens={screens}
				video={providedGameData.video}
			/>
			<SectionHeader>{t('gameOverview.about').toString()}</SectionHeader>
			<Flex
				flexDirection="column"
				gridGap="24px"
				overflow={{ base: 'hidden', hashup: 'visible' }}
				zIndex={5}
			>
				<Box
					mb={{ hashup: '80px', base: '20px' }}
					fontSize={{ base: '10px', hashup: '16px' }}
					lineHeight={{ base: '18px', hashup: '29px' }}
					fontWeight="300"
					maxHeight={{ base: isExpanded ? 'unset' : '4.75em', hashup: 'unset' }}
					overflow={{ base: 'hidden', hashup: 'visible' }}
				>
					<Text position="relative">{about}</Text>
				</Box>
				<Box
					display={{ base: 'block', hashup: 'none' }}
					mb="10px"
				>
					<Text
						textTransform="uppercase"
						fontWeight="600"
						fontSize="8px"
						lineHeight="10px"
						letterSpacing=".4em"
						cursor="pointer"
						onClick={toggleIsExpanded}
					>
						{t(isExpanded ? 'gameOverview.collapse' : 'gameOverview.expand').toString()}
					</Text>
				</Box>
			</Flex>
		</Flex>
	);
};
